import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ProspectProfileSectionProps } from './types';
import { RootState } from '../../../../../../../../store/root-reducer';
import { ProspectProfileSection } from './prospect-profile-section';
import {
  getSingleProspectDetailsRequest,
  getSingleProspectSequencesDetailsRequest,
} from '../../../../../../extra-actions';
import { getCustomOutcomeRequest } from '../../../../../../../settings/components/custom-outcomes/extra-actions';

const ProspectProfileSectionContainer = (
  props: ProspectProfileSectionProps,
) => {
  const dispatch = useDispatch();
  const getSingleProspectDetailsRequests = (contactId: number) => {
    dispatch(getSingleProspectDetailsRequest(contactId));
  };
  const fetchSingleProspectSequencesDetails = (contactId: number) => {
    dispatch(getSingleProspectSequencesDetailsRequest(contactId));
  };
  const getCustomOutcomeRequests = () => {
    dispatch(getCustomOutcomeRequest());
  };

  const singleProspectResponse = useSelector(
    (state: RootState) => state?.prospect?.getSingleProspect,
  );
  const getPrimaryEmailChangeInProspectRequestStatus = useSelector(
    (state: RootState) =>
      state?.prospect?.changePrimaryEmailInProspectRequest.status,
  );
  const getUpdatePrimaryNumberRequestStatus = useSelector(
    (state: RootState) => state?.prospect?.updatePrimaryNumberRequest.status,
  );

  const singleProspectDetailsRequestStatus = useSelector(
    (state: RootState) =>
      state?.prospect?.getSingleProspectDetailsRequest.status,
  );

  const addTagsToProspectsRequest = useSelector(
    (state: RootState) => state?.prospect?.addTagsToProspectsRequest.status,
  );

  const removeTagsFromProspectsRequestStatus = useSelector(
    (state: RootState) =>
      state?.prospect?.removeTagsFromProspectsRequest.status,
  );

  const isDialerFeatureEnabled = useSelector(
    (state: RootState) => state.home.isDialerFeatureEnabled,
  );
  const isAgencyUser = useSelector(
    (state: RootState) => state.home.isAgencyUser,
  );

  return (
    <ProspectProfileSection
      {...props}
      isDialerFeatureEnabled={isDialerFeatureEnabled}
      isAgencyUser={isAgencyUser}
      getSingleProspectDetailsRequests={getSingleProspectDetailsRequests}
      getCustomOutcomeRequests={getCustomOutcomeRequests}
      singleProspectResponse={singleProspectResponse}
      getPrimaryEmailChangeInProspectRequestStatus={
        getPrimaryEmailChangeInProspectRequestStatus
      }
      getUpdatePrimaryNumberRequestStatus={getUpdatePrimaryNumberRequestStatus}
      singleProspectDetailsRequestStatus={singleProspectDetailsRequestStatus}
      fetchSingleProspectSequencesDetails={fetchSingleProspectSequencesDetails}
      addTagsToProspectsRequest={addTagsToProspectsRequest}
      removeTagsFromProspectsRequestStatus={removeTagsFromProspectsRequestStatus}
    />
  );
};

export default ProspectProfileSectionContainer;
